import { ReactNode } from 'react';
import GridIcon from '../../assets/icons/grid.svg?react';
import ListIcon from '../../assets/icons/list.svg?react';
import TableIcon from '../../assets/icons/table.svg?react';
import { IconButton } from '../../components/IconButton';
import { MachineView } from './useMachineViewMode';

interface MachineViewToggleProps {
  view: MachineView;
  /** The layouts to cycle. A phone offers two, a tablet three. */
  views: readonly MachineView[];
  onChange: (view: MachineView) => void;
}

const ICONS: Record<MachineView, ReactNode> = {
  table: <TableIcon />,
  grid: <GridIcon />,
  list: <ListIcon />,
};

/**
 * One button for the layouts a tier offers. It names and shows the next one.
 * The icon carries it alone, on a hit area a finger still finds.
 */
export function MachineViewToggle({
  view,
  views,
  onChange,
}: MachineViewToggleProps) {
  const next = views[(views.indexOf(view) + 1) % views.length];

  return (
    <IconButton
      aria-label={`Show as ${next}`}
      icon={ICONS[next]}
      iconSize='md'
      onClick={() => onChange(next)}
      className='text-focus h-11 w-11 rounded hover:bg-transparent'
    />
  );
}
